// extracted by mini-css-extract-plugin
export default {"title":"AboutBlock_title__WWco9","text":"AboutBlock_text__S8OQk","btn":"AboutBlock_btn__wtfkD"};